module.exports = __webpack_public_path__ + "img/my-life-cross-search.4cdbc803.png";